module.exports = __webpack_public_path__ + "static/EverForward5-de93010355035921d9ab16d05531b27d.webp";